import { ReactElement } from 'react'
import { CenterFocusStrong as CenterFocusStrongIcon } from '@mui/icons-material'
import { IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface Props extends IconButtonProps {
  hint?: string
}

const FocusIconButton = ({ hint = 'Auf Elemente fokussieren', ...props }: Props): ReactElement => {
  return (
    <Tooltip title={hint}>
      <IconButton size="small" {...props}>
        <CenterFocusStrongIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default FocusIconButton
